import { render, staticRenderFns } from "./DoctorCompliance.vue?vue&type=template&id=5b80371c&scoped=true"
import script from "./DoctorCompliance.vue?vue&type=script&lang=js"
export * from "./DoctorCompliance.vue?vue&type=script&lang=js"
import style0 from "./DoctorCompliance.vue?vue&type=style&index=0&id=5b80371c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b80371c",
  null
  
)

export default component.exports